import { Layer } from 'react-map-gl/mapbox'

import type { FC } from 'react'

interface StyledMapLineLayerProps {
	beforeId?: string
	id: string
	'source-layer': string
}

export const StyledMapLineLayer: FC<StyledMapLineLayerProps> = (props) => {
	return (
		<Layer
			{...props}
			type="line"
			paint={{
				'line-color': '#3A2E2F',
				'line-opacity': 0.2,
				'line-width': 1,
			}}
		/>
	)
}
